import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    stepper: {
      padding: theme.spacing(3),
      background: "#fff"
    },
    stepperButtons: {
      position: "sticky",
      bottom: 0,
      opacity: "1.0",
      zIndex: 999,
      background: "#fafafa !important",
    },
    backButton: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    nextButton: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);
